import http from './utils';
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
import { getLinkDomain } from '@op/utils/url';
const CancelToken = axios.CancelToken;

export const getKeywordDrillStats: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) =>
  http({
    url: `${prefix}/summary/keyword_drill/stats`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;

export const getUserSummaryList: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) =>
  http({
    url: `${prefix}/summary/keyword_drill/user_summary_list`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;

export const deleteUserSummary: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) =>
  http({
    url: `${prefix}/summary/keyword_drill/del_user_summary`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;

export const getUserSummaryInfo: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) =>
  http({
    url: `${prefix}/summary/keyword_drill/user_summary_info`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;

export const updateSummaryKeywordDrillUserInfo: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/ai_analysis/update_keyword_analysis_task_queue`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const resetSummaryInfo: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/reset_summary`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const updateSummaryUrlDrill: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/keyword_drill/update_url_summary_task`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const addSummaryKeywrodUrlList: (
  payload: any,
) => Promise<any> = payload => {
  return http({
    url: `${prefix}/summary/keyword_drill/add_user_summary`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getUrlDrillEngagement: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/keyword_drill/url_stats_engagement`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getUrlDrillViewTimeline: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/keyword_drill/url_stats_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export function createUrlDrillTask(payload: any) {
  return http({
    url: `${prefix}/summary/keyword_drill/create_url_task`,
    method: 'post',
    data: { ...payload, link_url_domain: getLinkDomain() },
    errorHandler: true,
  }) as Promise<any>;
}

export function getUrlDrillTaskList(
  payload: any,
  cancelTokenFunc = (c: any) => {},
) {
  return http({
    url: `${prefix}/summary/keyword_drill/get_url_task_id_list`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
}

/**
 * 返回校验失败的值
 * @param payload
 * @param cancelTokenFunc
 * @returns
 */
export function checkUrlPattern(
  payload: any,
  cancelTokenFunc = (c: any) => {},
) {
  return http({
    url: `${prefix}/summary/keyword_drill/check_url_pattern`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
}

export const getSummaryUpdateLog: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/get_summary_update_log`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const createKeywordAnalysisTask: (
  payload: any,
  cancelTokenFunc?: any,
) => Promise<any> | any = (payload, cancelTokenFunc = () => {}) => {
  return http({
    url: `${prefix}/ai_analysis/create_keyword_analysis_task`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
};

/**
 * 获取关键词分析任务信息（轮询用）
 * @param payload - { id: number, type?: string }
 * @returns Promise<任务信息>
 */
export const getKeywordAnalysisTaskInfo: (
  payload: any,
) => Promise<any> | any = payload =>
  http({
    url: `${prefix}/ai_analysis/keyword_analysis_task_info`,
    method: 'post',
    ...payload,
  }) as Promise<any>;

/**
 * 获取关键词分析任务列表（Subscriptions Tab 专用）
 * @param payload - 分页和筛选参数
 * @param cancelTokenFunc - 取消令牌函数
 * @returns Promise<任务列表>
 */
export const getKeywordAnalysisTaskList: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) =>
  http({
    url: `${prefix}/ai_analysis/keyword_analysis_task_list`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;

/**
 * 获取主题分析任务回调状态（轮询打标进度）
 * @param payload - { id: number, ...gameInfo }
 * @param cancelTokenFunc - 取消令牌函数
 * @returns Promise<任务状态>
 */
export const getKeywordAnalysisTaskCallbackStatus: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_analysis/keyword_analysis_task_callback_list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 更新关键词分析任务（预览页面点击 confirm）
 * @param payload - { summary_collect_id: number, ...gameInfo }
 * @returns Promise<任务信息>
 */
export const updateKeywordAnalysisTask: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_analysis/update_keyword_analysis_task`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

/**
 * 获取topic列表
 */
export const getTopicSelectList: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_analysis/keyword_analysis_task_custom_topic_list`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const cancelTopicAnalysisTask: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_analysis/cancel_keyword_analysis_task`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const readAnalysisTaskReport: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_analysis/set_keyword_analysis_task_queue_read`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

/**
 * 判断语义理解是不否不限制日期
 * @returns
 */
export const checkSummaryConfig: () => Promise<any> | any = () => {
  return http({
    url: `${prefix}/ai_analysis/check_summary_config`,
    method: 'post',
    errorHandler: true,
  }) as Promise<any>;
};

export const getTopicAnalysisTimeline: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> = (payload, cancelTokenFunc = c => {}) =>
  http({
    url: `${prefix}/ai_analysis/topic_analysis_topics_timeline`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
